import { render } from "./detalleInstrumento.vue?vue&type=template&id=79cb9cb9&scoped=true"
import script from "./detalleInstrumento.vue?vue&type=script&lang=js"
export * from "./detalleInstrumento.vue?vue&type=script&lang=js"

import "./detalleInstrumento.vue?vue&type=style&index=0&id=79cb9cb9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79cb9cb9"]])

export default __exports__